// Suitability Records: the routes and the sidebar rows of `wealth.onboarding.suitability-records` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.onboarding.suitability-records',
    routes: [
        {
            frontend: 'desk',
            path: 'suitability-records',
            lazy: () => import('@/pages/desk/suitability-records/page'),
        },
        {
            frontend: 'desk',
            path: 'suitability-records/:recordId',
            lazy: () => import('@/pages/desk/suitability-records/record/page'),
        },
        {
            frontend: 'ops',
            path: 'suitability-records',
            lazy: () => import('@/pages/ops/suitability-records/page'),
        },
        {
            frontend: 'ops',
            path: 'suitability-records/:recordId',
            lazy: () => import('@/pages/ops/suitability-records/record/page'),
        },
        {
            frontend: 'comply',
            path: 'suitability-records',
            lazy: () => import('@/pages/comply/suitability-records/page'),
        },
        {
            frontend: 'comply',
            path: 'suitability-records/:recordId',
            lazy: () => import('@/pages/comply/suitability-records/record/page'),
        },
    ],
    nav: [
        // SuitabilityRecord SUR mandate containers (ADR-0015 Stage 2) — the
        // approval surface; the KYC assessment content renders here only (D5).
        {
            frontend: 'comply',
            key: 'suitability-records',
            label: 'Suitability Records',
            href: '/comply/suitability-records',
            icon: 'FileCheck',
            group: 'clients-kyc',
            order: 380,
        },
        // SuitabilityRecord SUR mandate containers (ADR-0015 Stage 2) — the IM's
        // own book. Open to im-assistant, which reads the book of the IM it acts
        // for (D0.3; see persona-model.ts).
        {
            frontend: 'desk',
            key: 'suitability-records',
            label: 'Suitability Records',
            href: '/desk/suitability-records',
            icon: 'FileCheck',
            group: 'advice-suitability',
            order: 430,
        },
        // SuitabilityRecord SUR mandate containers (ADR-0015 Stage 2) — firm-wide
        // with edit rights + the ops-mediated owner move (D0.2).
        {
            frontend: 'ops',
            key: 'suitability-records',
            label: 'Suitability Records',
            href: '/ops/suitability-records',
            icon: 'FileCheck',
            group: 'client-operations',
            order: 460,
        },
    ],
});
